// Pick a resized variant of a lawyer profile photo served by /api/lawyer-photos/{id}.
// size: "sm" (≈128px, avatars ≤64px) | "md" (≈512px, profile/detail). Non-API URLs pass through.
export function photoSrc(url, size) {
  if (!url || !size || !/\/api\/lawyer-photos\//.test(url) || /[?&]size=/.test(url)) return url || null;
  return `${url}${url.includes("?") ? "&" : "?"}size=${size}`;
}
